// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2As5R","controls":"styles_controls__sZW5F","charLimit":"styles_charLimit__3AbzP","input":"styles_input__38caC","send":"styles_send__33BhM"};